import { useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'
import { GET_STORYOUS_TOKEN_QUERY_KEY, STORYOUS_STORAGE_KEY } from '~/features/storyous/constants'
import { fetchAuthToken } from '~/features/storyous/hooks/useGetAuthToken'

export const useHandleMissingToken = () => {
  const queryClient = useQueryClient()

  return (response: Response) => {
    if (response.status === 403 || response.status === 401) {
      localStorage.removeItem(STORYOUS_STORAGE_KEY)

      const promise = queryClient.fetchQuery({
        queryKey: [GET_STORYOUS_TOKEN_QUERY_KEY],
        queryFn: fetchAuthToken,
        staleTime: 0,
      })

      toast.promise(promise, {
        id: 'auth-token',
        loading: 'Storyous auth key is expired. Refetching...',
        success: 'Token fetched successfully',
        error: 'Token could not be fetched',
      })

      return true
    }
    return false
  }
}
